/**
 * Ustawienia oceny wymowy Azure, z którymi aplikacja pracuje — w JEDNYM miejscu, żeby dało się je zapisać przy nagraniu do strojenia (SPEC §23.40)
 * i powtórzyć ocenę tego samego pliku w tych samych warunkach. `lang` i `segmentationSilenceMs` sterują zachowaniem (używa ich `azure.ts`); pozostałe pola
 * opisują to, co `runAzureAssessment` ustawia w SDK na stałe (test w `tests/speech.test.ts` pilnuje, że opis zgadza się z tym, co dostaje SDK).
 */
export const ASSESS_SETTINGS = {
  lang: 'en-US',
  /** Pauza (ms) kończąca wypowiedź — dłuższa niż domyślna, bo dzieci robią przerwy w zdaniu. */
  segmentationSilenceMs: 1500,
  grading: 'HundredMark',
  granularity: 'Phoneme',
  miscue: true,
  prosody: true,
  /** Zwykłe rozpoznawanie (bramka treści) działa na formacie „Detailed”, bez wzorca. */
  plainOutput: 'Detailed',
} as const;
